import axios from 'axios';
import {INTERACE_SAAS_ORDER_BASE_URL} from 'src/config/params-local';
import {
  setSessionStorageItem,
  getSessionStorageItem,
  getClientType,
  getLocalStorageItem,
  setLocalStorageItem
} from 'components/api/utils';
import { getUserIdentity, logging } from 'components/api/interface-hhy';
import {BUSINESS_TYPE_TS, BUSINESS_TYPE_MC, BUSINESS_TYPE_ZT, BUSINESS_TYPE_WS} from 'components/api/interface-saas';
import { TS_PAY_TYPE_AFTER, TS_PAY_TYPE_NOPAY } from './interface-saas';
import store from 'src/config/store.config';

/**
 * 订单支付状态 SUCCESS,WAITING,FAIL，CHECKING
 * WAITING|FAIL且剩余时间>0,可以进行支付操作
 */
export const ORDER_PAY_SUCCESS = 'SUCCESS';
export const ORDER_PAY_WAITING = 'WAITING';
export const ORDER_PAY_FAIL = 'FAIL';
export const ORDER_PAY_CHECKING = 'CHECKING';
export const ORDER_PAY_TIME_OUT = 'TIME_OUT';

/*
 * 未接单（交易创建等待商家接单）WAIT_RECEIVE_ORDER
 * 商家已经接单BRANCH_RECEIVED_ORDER
 * 商家取消订单BRANCH_CANCELED_ORDER
 * 订单完成ORDER_FINISHED
 * 订单制作中ORDER_MAKEING,
 * PAY_TIMEOUT:因为支付超时而取消
 */
export const ORDER_STATUS_WAIT_RECEIVE_ORDER = 'WAIT_RECEIVE_ORDER';
export const ORDER_STATUS_BRANCH_RECEIVED_ORDER = 'BRANCH_RECEIVED_ORDER';
export const ORDER_STATUS_BRANCH_CANCELED_ORDER = 'BRANCH_CANCELED_ORDER';
export const ORDER_STATUS_ORDER_FINISHED = 'ORDER_FINISHED';
export const ORDER_STATUS_ORDER_MAKEING = 'ORDER_MAKEING';
export const ORDER_STATUS_ORDER_MAKING = 'ORDER_MAKEING';

// 优惠 SCORE积分 COUPON卡券
export const DISCOUNT_SCORE = 'SCORE';
export const DISCOUNT_COUPON = 'COUPON';
export const DISCOUNT_MAP = {
  [DISCOUNT_SCORE]: '积分',
  [DISCOUNT_COUPON]: '抵用券'
};

// 支付方式：ALIPAY支付宝，WECHAT 微信，CARDPAY好会员支付
export const PAY_TYPE_ALIPAY = 'ALIPAY';
export const PAY_TYPE_WECHAT = 'WECHAT';
export const PAY_TYPE_CARDPAY = 'CARDPAY';
export const PAY_TYPE_ANOTHER_MOBILE = 'ANOTHER_MOBILE'; // 好友手机代付
export const PAY_TYPE_ANOTHER_SHARE = 'ANOTHER_SHARE'; // 好友分享代付
export const PAY_TYPE_MAP = {
  [PAY_TYPE_ALIPAY]: '支付宝支付',
  [PAY_TYPE_WECHAT]: '微信支付',
  [PAY_TYPE_CARDPAY]: '会员优惠买单'
};

/**
 * 创建axios实例
 * @return {axios}
 */
export function createHttp() {
  let $httpSaas = axios.create({
    baseURL: INTERACE_SAAS_ORDER_BASE_URL,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    timeout: 30000
  });
// 添加一个响应拦截器
  $httpSaas.interceptors.response.use(res => {
    if (res.data.code && res.data.code === -1) {
      logging({ request: res.request, responseData: res.data });
      let errMsg = {message: res.data.msg || ''};
      return Promise.reject(errMsg);
    }
    return 'body' in res.data ? res.data.body : res.data;
  }, err => {
    let responseData = err.response ? err.response.data : null;
    logging({
      request: err.request,
      responseData,
      err: responseData ? null : err
    });
    let errorInfo = err.response ? err.response.data : err;
    return Promise.reject(errorInfo);
  });
  return $httpSaas;
}

/**
 * 创建axios实例--测试
 * 测试使用
 * return createHttpTest.get('static/test/xxx.json');
 * @return {axios}
 */
export function createHttpTest() {
  let $httpSaas = axios.create();
// 添加一个响应拦截器
  $httpSaas.interceptors.response.use(res => {
    if (res.data.code && res.data.code === -1) {
      logging({ request: res.config, responseData: res.data });
      let errMsg = {response: {data: {message: res.data.msg ? res.data.msg : ''}}};
      return Promise.reject(errMsg);
    }
    return res.data.body ? res.data.body : res.data;
  }, err => {
    let responseData = err.response ? err.response.data : null;
    logging({
      request: err.config,
      responseData,
      err: responseData ? null : err
    });
    return Promise.reject(err);
  });
  return $httpSaas;
}

/**
 * 订单状态
 * @param {String} payStatus
 * @param {String} status
 */
export function orderStatus(payStatus, status) {
  if (status === store.state.appConst.ORDER_STATUS_PRE_ORDER) {
    return '待下单';
  }
  switch (payStatus) {
    case ORDER_PAY_WAITING:
      return '待支付';
    case ORDER_PAY_FAIL:
      return '支付失败';
    case ORDER_PAY_CHECKING:
      return '支付确认中';
    case ORDER_PAY_TIME_OUT:
      return '已取消';
    case ORDER_PAY_SUCCESS:
      return '已完成';
  }
  return ' ';
}
/**
 * 订单描述
 * @param {String} payStatus
 * @param {String} status
 */
export function orderDescription(payStatus, status) {
  switch (payStatus) {
    case ORDER_PAY_WAITING:
    case ORDER_PAY_FAIL:
      return '订单未支付，超时将自动取消';
    case ORDER_PAY_CHECKING:
      return '支付处理中，请稍后确认';
    case ORDER_PAY_TIME_OUT:
      return '超时未支付';
    case ORDER_PAY_SUCCESS:
      return '感谢您对本店的支持，欢迎再次光临';
  }
  return ' ';
}

/**
 * 订单支付方式
 * @param {String} payStatus
 * @param {String} payType
 */
export function orderPayType(payStatus, payType) {
  if (payStatus !== ORDER_PAY_SUCCESS) {
    return '尚未支付';
  }
  return PAY_TYPE_MAP[payType] ? PAY_TYPE_MAP[payType] : '';
}

/**
 * 判断订单是否可支付
 * @param order
 * @return {boolean}
 */
export function orderCanPay(order) {
  let checkMode = order.checkMode;
  return order.preorder !== store.state.appConst.PRE_ORDER_Y &&
    (order.timeLeft > 0 || checkMode === TS_PAY_TYPE_AFTER) &&
    (order.payStatus === ORDER_PAY_WAITING || order.payStatus === ORDER_PAY_FAIL);
}

/**
 * 判断订单是否可【再来一单】
 * @param order
 * @return {boolean}
 */
export function orderCanCopy(order) {
  return order.orderType !== BUSINESS_TYPE_TS && order.payStatus === ORDER_PAY_SUCCESS;
}

/**
 * 预点餐：POST /v1/order/pre/submit
 * 下单：/order
 * @param params
 */
export function orderCreate(params) {
  let userIdentity = getUserIdentity(),
    isPreOrder = userIdentity.businessType === BUSINESS_TYPE_TS && !userIdentity.tableId && !userIdentity.tableNo,
    url = isPreOrder ? '/order/pre/submit' : '/order';
  let {
    id = 0,
    mobile,
    persons = 1,
    note = '',
    arriveTime = 0,
    personNum = 0,
    receiver = '',
    deliverAddress = '',
    foodList = [],
    needPayCost = 0,
    token = ''
  } = params;
  let {
    branchId,
    businessType,
    userId,
    levelType,
    tableId = 0,
    tableNo = '',
    orgId,
    uid
  } = userIdentity;
  let newParams = {
    id,
    branchId,
    orderChannel: getClientType(),
    mobile,
    orderType: businessType,
    persons,
    orderUser: userId,
    note,
    tableId,
    tableNo,
    arriveTime,
    personNum,
    receiver,
    deliverAddress,
    customerLevel: levelType,
    foodList,
    orgId,
    uid,
    needPayCost,
    token
  };
  let $httpSaas = createHttp();
  return $httpSaas.post(url, newParams);
}

//
/**
 * GET /v1/branch/{branchId}/order/{orderId}
 * 查询订单详情
 * @param orderId
 * @param branchId
 * @return {Promise}
 */
export function getOrderDetail(orderId, branchId = 0) {
  let userIdentity = getUserIdentity(),
    levelType = userIdentity.levelType,
    token = new Date().getTime();
  branchId = branchId || userIdentity.branchId;
  let url = `/branch/${branchId}/order/${orderId}?vip=${levelType}&r=${token}`;
  let $httpSaas = createHttp();
  $httpSaas.interceptors.response.use(res => {
    if (res.preorder === store.state.appConst.PRE_ORDER_Y && res.status === store.state.appConst.ORDER_STATUS_PRE_ORDER) {  // 未下单的预点餐
      // 就餐人数
      store.commit('setPersonNum', res.persons);
      // 整单备注
      store.commit('setOrderNote', res.note);
      // 预点餐信息
      store.commit('setPreOrderDetail', res);
    }
    return Promise.resolve(res);
  }, err => {
    return Promise.reject(err);
  });
  return $httpSaas.get(url);
}

/**
 * GET /v1/org-id/{orgId}/order-user/{orderUserId}/order/{beginDay}/{endDay}
 * @param page 第几页
 * @return {Promise}
 */
export function getOrderList(page = 1) {
  let beginDay = 90 * (page - 1);
  let endDay = 90 * page;
  let userIdentity = getUserIdentity();
  let url = '/org-id/' + userIdentity.orgId +
    '/order-user/' + userIdentity.userId +
    '/order/' + beginDay +
    '/' + endDay;
  let $httpSaas = createHttp();
  return $httpSaas.get(url);
}

/**
 * 订单支付
 * 如果是微信和支付宝支付，服务器生成统一下单结果后告知客户端，客户端调起JSAPI，支付成功后跳转支付结果页面并通知saas支付结果
 * 如果是好会员支付，服务器直接调起好会员接口处理卡券、积分、储值卡消费
 * @author ytl
 * @param params
 * @return {Promise}
 */
export function orderPay(params) {
  let {orderId, payType, discountList, topay, payUser} = params;
  let userIdentity = getUserIdentity(),
    requestId = (new Date().getTime()) + '' + orderId;
  let url = '/payment';
  let $httpSaas = createHttp();
  return $httpSaas.post(url, {
    uid: userIdentity.uid,
    authId: userIdentity.authId,
    branchId: userIdentity.branchId,
    orderId: orderId,
    orgId: userIdentity.orgId,
    payType: payType,
    payUser: payUser,
    requestId: requestId,
    discountList,
    topay,
    mobilePayUser: userIdentity.userId
  });
}

/**
 * 微信/支付宝JSAPI支付成功后通知saas支付结果
 * post payment-notify
 * @param {String} outTradeNo 支付宝/微信统一下单的外部交易号
 * @return {Promise}
 */
export function orderPayNotify(outTradeNo) {
  let userIdentity = getUserIdentity();
  let url = '/payment-notify';
  let $http = createHttp();
  return $http.post(url, {
    branchId: userIdentity.branchId,
    orgId: userIdentity.orgId,
    outTradeNo: outTradeNo
  });
}
/**
 * 查询某用户在门店台位的结账信息(如果已结算，返回结算账单信息，否则返回未结算，需要前端去门店查询最新下单信息
 * GET /v1/{branchid}/{tableid}/{tableno}/{uid}/cash/status
 * @return {Promise}
 */
export function getTableFinishedOrder () {
  let {branchId, tableId, tableNo, userId} = getUserIdentity(),
    url = `/${branchId}/${tableId}/${tableNo}/${userId}/cash/status`,
    $http = createHttp();
  return $http.get(url);
}

/**
 * 必点菜用，查询是否下单
 * GET /v1/check/has-bill/{userid}/{branchid}/{tableno}
 * @return {Promise}
 */
export function checkHasBill () {
  let {branchId, tableNo, userId} = getUserIdentity(),
    url = `/check/has-bill/${userId}/${branchId}/${tableNo}`,
    $http = createHttp();
  return $http.get(url);
}

/**
 * 后支付结账
 * POST /v1/scan/code/payment
 * @param {Object} params 结账参数
 * @return {Promise}
 */
export function afterPay (params) {
  let {
    orgId,
    authId,
    branchId,
    uid,
    levelType,
    mobile = '',
    userId,
    tableId = 0,
    tableNo = '',
    tableName = '',
    showname = ''
  } = getUserIdentity();
  let orderChannel = getClientType();
  Object.assign(params, {
    orgId,
    authId,
    branchId,
    brandId: uid,
    orderChannel,
    customerLevel: levelType,
    mobile,
    tableId,
    tableName,
    tableno: tableNo,
    uname: showname,
    mobilePayUser: userId
  });
  let url = '/scan/code/payment';
  return createHttp().post(url, params);
}
/**
 * 查询用户待下单的预点餐
 * GET /v1/order/{branchid}/{uid}/summary
 * @return {Promise}
 */
export function getUserPreOrderSummary () {
  let {branchId, userId} = getUserIdentity();
  let url = `/order/${branchId}/${userId}/summary`;
  return createHttp().get(url);
}



// WEBPACK FOOTER //
// ./src/components/api/interface-saas-order.js